 const defaultHtml = `<form method="post" id="eloquaForm" name="eloquaForm" class="cmp-form-area">
    <div class="row">
        <div class="col-md-6">
            <input class="field fname" id="form-firstname" name="FirstName" placeholder="First Name" type="text"/>
        </div>
  
        <div class="col-md-6">
            <input class="field lname" id="form-lastname" name="LastName" placeholder="Last Name" type="text"/>
        </div>
    </div>
  
    <div class="row">
        <div class="col-md-6">
            <input class="field fname" id="form-custservsubmitemail" name="Email" placeholder="Email" type="text"/>
        </div>
  
        <div class="col-md-6">
            <input class="field fname" id="form-custservsubmitphone" name="Phone" placeholder="Phone" type="text"/>
        </div>
    </div>
  
    <div class="row">
        <div class="col-md-6">
            <select class="field job-title" id="form-jobtitle" name="Title" size="1">
                <option value="">Select a Title</option>
                <option value="Owner/Partner">Owner/Partner</option>
                <option value="President/CEO/COO">President/CEO/COO</option>
                <option value="Controller/CFO">Controller/CFO</option>
                <option value="CMO">CMO</option>
                <option value="CTO/CIO">CTO/CIO</option>
                <option value="Contracting Officer">Contracting Officer</option>
                <option value="VP/SVP/Director">VP/SVP/Director</option>
                <option value="Manager/Supervisor">Manager/Supervisor</option>
                <option value="Admin/Support">Admin/Support</option>
                <option value="Sales Representative">Sales Representative</option>
                <option value="Assistant/Associate">Assistant/Associate</option>
                <option value="Analyst">Analyst</option>
                <option value="Consultant">Consultant</option>
                <option value="Professional">Professional</option>
                <option value="Researcher">Researcher</option>
                <option value="Broker">Broker</option>
                <option value="Attorney">Attorney</option>
                <option value="Editor/Writer">Editor/Writer</option>
                <option value="Reporter">Reporter</option>
                <option value="Educator/Librarian">Educator/Librarian</option>
                <option value="Job Seeker">Job Seeker</option>
                <option value="Student">Student</option>
                <option value="Retired">Retired</option>
                <option value="Agent">Agent</option>
                <option value="Unemployed">Unemployed</option>
                <option value="Other">Other</option>
            </select>
        </div>
  
        <div class="col-md-6">
            <input class="field fname" id="form-companyname" name="Company" placeholder="Company" type="text"/>
        </div>
    </div>
  
    <div class="row">
        <div class="col-md-12">
            <input class="field fname" id="form-address" name="Address" placeholder="Company Street Address"
                   type="text"/>
        </div>
    </div>
  
    <div class="row">
        <div class="col-md-6">
            <input class="field fname" id="form-postalcode" name="PostalCode" placeholder="ZIP Code" type="text"/>
        </div>
  
        <div class="col-md-6">
            <select class="field country" name="Country" size="1" id="form-country">
                <option value="US">United States</option>
                <option value="CA">Canada</option>
                <option value="GB">United Kingdom</option>
                <option value="AF">Afghanistan</option>
                <option value="AX">Åland Islands</option>
                <option value="AL">Albania</option>
                <option value="DZ">Algeria</option>
                <option value="AS">American Samoa</option>
                <option value="AD">Andorra</option>
                <option value="AO">Angola</option>
                <option value="AI">Anguilla</option>
                <option value="AQ">Antarctica</option>
                <option value="AG">Antigua and Barbuda</option>
                <option value="AR">Argentina</option>
                <option value="AM">Armenia</option>
                <option value="AW">Aruba</option>
                <option value="AU">Australia</option>
                <option value="AT">Austria</option>
                <option value="AZ">Azerbaijan</option>
                <option value="BS">Bahamas</option>
                <option value="BH">Bahrain</option>
                <option value="BD">Bangladesh</option>
                <option value="BB">Barbados</option>
                <option value="BY">Belarus</option>
                <option value="BE">Belgium</option>
                <option value="BZ">Belize</option>
                <option value="BJ">Benin</option>
                <option value="BM">Bermuda</option>
                <option value="BT">Bhutan</option>
                <option value="BO">Bolivia</option>
                <option value="BQ">Bonaire</option>
                <option value="BA">Bosnia and Herzegovina</option>
                <option value="BW">Botswana</option>
                <option value="BV">Bouvet Island</option>
                <option value="BR">Brazil</option>
                <option value="IO">Brit/Indian Ocean Terr.</option>
                <option value="BN">Brunei Darussalam</option>
                <option value="BG">Bulgaria</option>
                <option value="BF">Burkina Faso</option>
                <option value="BI">Burundi</option>
                <option value="KH">Cambodia</option>
                <option value="CM">Cameroon</option>
                <option value="CV">Cape Verde</option>
                <option value="KY">Cayman Islands</option>
                <option value="CF">Central African Republic</option>
                <option value="TD">Chad</option>
                <option value="CL">Chile</option>
                <option value="CN">China</option>
                <option value="CX">Christmas Island</option>
                <option value="CC">Cocos (Keeling) Islands</option>
                <option value="CO">Colombia</option>
                <option value="KM">Comoros</option>
                <option value="CG">Congo</option>
                <option value="CD">Congo, The Dem. Republic Of</option>
                <option value="CK">Cook Islands</option>
                <option value="CR">Costa Rica</option>
                <option value="CI">Côte d’Ivoire</option>
                <option value="HR">Croatia</option>
                <option value="CU">Cuba</option>
                <option value="CW">Curacao</option>
                <option value="CY">Cyprus</option>
                <option value="CZ">Czech Republic</option>
                <option value="DK">Denmark</option>
                <option value="DJ">Djibouti</option>
                <option value="DM">Dominica</option>
                <option value="DO">Dominican Republic</option>
                <option value="EC">Ecuador</option>
                <option value="EG">Egypt</option>
                <option value="SV">El Salvador</option>
                <option value="GQ">Equatorial Guinea</option>
                <option value="ER">Eritrea</option>
                <option value="EE">Estonia</option>
                <option value="ET">Ethiopia</option>
                <option value="FK">Falkland Islands</option>
                <option value="FO">Faroe Islands</option>
                <option value="FJ">Fiji</option>
                <option value="FI">Finland</option>
                <option value="FR">France</option>
                <option value="GF">French Guiana</option>
                <option value="PF">French Polynesia</option>
                <option value="TF">French Southern Terr.</option>
                <option value="GA">Gabon</option>
                <option value="GM">Gambia</option>
                <option value="GE">Georgia</option>
                <option value="DE">Germany</option>
                <option value="GH">Ghana</option>
                <option value="GI">Gibraltar</option>
                <option value="GR">Greece</option>
                <option value="GL">Greenland</option>
                <option value="GD">Grenada</option>
                <option value="GP">Guadeloupe</option>
                <option value="GU">Guam</option>
                <option value="GT">Guatemala</option>
                <option value="GN">Guinea</option>
                <option value="GW">Guinea-Bissau</option>
                <option value="GY">Guyana</option>
                <option value="HT">Haiti</option>
                <option value="HM">Heard/McDonald Isls.</option>
                <option value="HN">Honduras</option>
                <option value="HK">Hong Kong SAR</option>
                <option value="HU">Hungary</option>
                <option value="IS">Iceland</option>
                <option value="IN">India</option>
                <option value="ID">Indonesia</option>
                <option value="IR">Iran</option>
                <option value="IQ">Iraq</option>
                <option value="IE">Ireland</option>
                <option value="IL">Israel</option>
                <option value="IT">Italy</option>
                <option value="JM">Jamaica</option>
                <option value="JP">Japan</option>
                <option value="JO">Jordan</option>
                <option value="KZ">Kazakhstan</option>
                <option value="KE">Kenya</option>
                <option value="KI">Kiribati</option>
                <option value="KP">Korea (North)</option>
                <option value="KR">Korea (South)</option>
                <option value="XK">Kosovo</option>
                <option value="KW">Kuwait</option>
                <option value="KG">Kyrgyzstan</option>
                <option value="LA">Laos</option>
                <option value="LV">Latvia</option>
                <option value="LB">Lebanon</option>
                <option value="LS">Lesotho</option>
                <option value="LR">Liberia</option>
                <option value="LY">Libya</option>
                <option value="LI">Liechtenstein</option>
                <option value="LT">Lithuania</option>
                <option value="LU">Luxembourg</option>
                <option value="MO">Macau SAR</option>
                <option value="MK">Macedonia</option>
                <option value="MG">Madagascar</option>
                <option value="MW">Malawi</option>
                <option value="MY">Malaysia</option>
                <option value="MV">Maldives</option>
                <option value="ML">Mali</option>
                <option value="MT">Malta</option>
                <option value="MH">Marshall Islands</option>
                <option value="MQ">Martinique</option>
                <option value="MR">Mauritania</option>
                <option value="MU">Mauritius</option>
                <option value="YT">Mayotte</option>
                <option value="MX">Mexico</option>
                <option value="FM">Micronesia</option>
                <option value="MD">Moldova</option>
                <option value="MC">Monaco</option>
                <option value="MN">Mongolia</option>
                <option value="ME">Montenegro</option>
                <option value="MS">Montserrat</option>
                <option value="MA">Morocco</option>
                <option value="MZ">Mozambique</option>
                <option value="MM">Myanmar</option>
                <option value="MP">N. Mariana Isls.</option>
                <option value="NA">Namibia</option>
                <option value="NR">Nauru</option>
                <option value="NP">Nepal</option>
                <option value="NL">Netherlands</option>
                <option value="NC">New Caledonia</option>
                <option value="NZ">New Zealand</option>
                <option value="NI">Nicaragua</option>
                <option value="NE">Niger</option>
                <option value="NG">Nigeria</option>
                <option value="NU">Niue</option>
                <option value="NF">Norfolk Island</option>
                <option value="NO">Norway</option>
                <option value="OM">Oman</option>
                <option value="PK">Pakistan</option>
                <option value="PW">Palau</option>
                <option value="PS">Palestinian Territory, Occupied</option>
                <option value="PA">Panama</option>
                <option value="PG">Papua New Guinea</option>
                <option value="PY">Paraguay</option>
                <option value="PE">Peru</option>
                <option value="PH">Philippines</option>
                <option value="PN">Pitcairn</option>
                <option value="PL">Poland</option>
                <option value="PT">Portugal</option>
                <option value="PR">Puerto Rico</option>
                <option value="QA">Qatar</option>
                <option value="RE">Reunion</option>
                <option value="RO">Romania</option>
                <option value="RW">Rwanda</option>
                <option value="KN">Saint Kitts and Nevis</option>
                <option value="LC">Saint Lucia</option>
                <option value="SX">Saint Maarten</option>
                <option value="WS">Samoa</option>
                <option value="SM">San Marino</option>
                <option value="ST">Sao Tome/Principe</option>
                <option value="SA">Saudi Arabia</option>
                <option value="SN">Senegal</option>
                <option value="RS">Serbia</option>
                <option value="SC">Seychelles</option>
                <option value="SL">Sierra Leone</option>
                <option value="SG">Singapore</option>
                <option value="SK">Slovak Republic</option>
                <option value="SI">Slovenia</option>
                <option value="SB">Solomon Islands</option>
                <option value="SO">Somalia</option>
                <option value="ZA">South Africa</option>
                <option value="SS">South Sudan</option>
                <option value="ES">Spain</option>
                <option value="LK">Sri Lanka</option>
                <option value="SH">St. Helena</option>
                <option value="PM">St. Pierre and Miquelon</option>
                <option value="VC">St. Vincent and Grenadines</option>
                <option value="SD">Sudan</option>
                <option value="SR">Suriname</option>
                <option value="SJ">Svalbard/Jan Mayen Isls.</option>
                <option value="SZ">Swaziland</option>
                <option value="SE">Sweden</option>
                <option value="CH">Switzerland</option>
                <option value="SY">Syria</option>
                <option value="TW">Taiwan</option>
                <option value="TJ">Tajikistan</option>
                <option value="TZ">Tanzania</option>
                <option value="TH">Thailand</option>
                <option value="TL">Timor-Leste</option>
                <option value="TG">Togo</option>
                <option value="TK">Tokelau</option>
                <option value="TO">Tonga</option>
                <option value="TT">Trinidad and Tobago</option>
                <option value="TN">Tunisia</option>
                <option value="TR">Turkiye</option>
                <option value="XT">Turkish Republic of Northern Cyprus (TRNC)</option>
                <option value="TM">Turkmenistan</option>
                <option value="TC">Turks/Caicos Isls.</option>
                <option value="TV">Tuvalu</option>
                <option value="UG">Uganda</option>
                <option value="UA">Ukraine</option>
                <option value="AE">United Arab Emirates</option>
                <option value="UM">US Minor Outlying Is.</option>
                <option value="UY">Uruguay</option>
                <option value="UZ">Uzbekistan</option>
                <option value="VU">Vanuatu</option>
                <option value="VA">Vatican City</option>
                <option value="VE">Venezuela</option>
                <option value="VN">Vietnam</option>
                <option value="VG">Virgin Islands (British)</option>
                <option value="VI">Virgin Islands (U.S.)</option>
                <option value="WF">Wallis/Futuna Isls.</option>
                <option value="EH">Western Sahara</option>
                <option value="YE">Yemen</option>
                <option value="ZM">Zambia</option>
                <option value="ZW">Zimbabwe</option>
            </select>
        </div>
    </div>
  
    <div class="row">
        <div class="col-md-12">
            <textarea aria-label="How can we assist you?" class="field comment1" id="comment1" name="MktoPersonNotes"
                      placeholder="How can we assist you?" rows="4"></textarea>
        </div>
    </div>
  
    <input class="field city hidden" id="form-hidden-city" name="City" type="hidden"/>
    <input class="field stateProv hidden" id="form-hidden-state" name="State" type="hidden"/>
    <input class="field marketingAgreementStatus1 hidden" id="marketingAgreementStatus1"
           name="marketingAgreementStatus1" type="hidden"/>
    <input class="field creditonself hidden" id="creditonself" name="creditOnSelf1" value="0" type="hidden"/>
    <input class="field partnerName1 hidden" id="partnerName1" name="Partner_Name__c" type="hidden"/>
    <input class="field contactStatus1 hidden" id="contactStatus1" name="contactStatus1" type="hidden"/>
    <input class="field webvisitorDUNS1 hidden" id="webvisitorDUNS1" name="Webvisitor_DUNS__c" type="hidden"/>
    <input class="field webvisitordomesticUltimateDuns1 hidden" id="webvisitordomesticUltimateDuns1"
           name="Webvisitor_Domestic_Ultimate_DUNS__c" type="hidden"/>
    <input class="field webvisitorAnnualSales1 hidden" id="webvisitorAnnualSales1" name="Webvisitor_Annual_Sales__c"
           type="hidden"/>
    <input class="field webvisitorNumberOfEmployees1 hidden" id="webvisitorNumberOfEmployees1"
           name="webvisitorNumberOfEmployees1" type="hidden"/>
    <input class="field dialerEligiblePage1 hidden" id="dialerEligiblePage1" name="dialerEligiblePage1" type="hidden"/>
    <input class="field manualReviewFlag1 hidden" id="manualReviewFlag1" name="manualReviewFlag1" type="hidden"/>
    <input class="field leadsource hidden" id="leadsource" name="LeadSource" value="Hoovers Web Form" type="hidden"/>
    <input class="field leadType1 hidden" id="leadType1" name="Lead_Type__c" value="Web Form" type="hidden"/>
    <input class="field leadSourceOrig hidden" id="form-hidden-leadSourceOriginal" name="Lead_Source_Original__c"
           value="Web Form" type="hidden"/>
    <input class="field leadTypeOrig hidden" id="form-hidden-Lead_Type_Original__c" name="Lead_Type_Original__c"
           type="hidden"/>
    <input class="field leadPriority1 hidden" id="leadPriority1" name="Lead_Priority__c" value="Urgent" type="hidden"/>
    <input class="field uNDUNSdToLDR1 hidden" id="uNDUNSdToLDR1" name="uNDUNSdToLDR1" value="0" type="hidden"/>
    <input class="field sFDCLastCampaignID hidden" id="sFDCLastCampaignID" name="Campaign_ID__c" type="hidden"/>
    <input class="field CampaignID__c hidden" id="CampaignID__c" name="CampaignID__c" type="hidden"/>
    <input id="campaign_id_c" name="campaign_id_c" type="hidden"/>
    <input id="campaign_c" name="campaign_c" type="hidden"/>
    <input id="Campaign__c" name="Campaign__c" type="hidden"/>
    <input id="Campaign_Name__c" name="Campaign_Name__c" type="hidden"/>
    <input class="field sFDCLastCampaignName hidden" id="sFDCLastCampaignName" name="Last_Campaign_Name__c"
           type="hidden"/>
    <input class="field productInterest1 hidden" id="productInterest1" name="eLeads_Product_Interest__c" type="hidden"/>
    <input class="field solutionInterest1 hidden" id="solutionInterest1" name="Solution_Interest__c_contact"
           type="hidden"/>
    <input class="field preferredLanguage1 hidden" id="preferredLanguage1" name="preferredLanguage1" type="hidden"/>
    <input class="field siteOrigin1 hidden" id="siteOrigin1" name="Site_Origin__c" value="Hoovers" type="hidden"/>
    <input class="field IPAddress1 hidden" id="IPAddress1" name="IPAddress__c" type="hidden"/>
    <input class="field serv1 hidden" id="serv1" name="Serv_Value__c" type="hidden"/>
    <input class="field visitorFrom1 hidden" id="visitorFrom1" name="Visitor_From__c" type="hidden"/>
    <input class="field creativeID1 hidden" id="creativeid" name="Hoov_CreativeID__c" type="hidden"/>
    <input class="field visitorFromDate1 hidden" id="visitorFromDate1" name="Visitor_From_Date__c" type="hidden"/>
    <input class="field visitorID1 hidden" id="visitorID1" name="Visitor_ID__c" type="hidden"/>
    <input class="field adobeID1 hidden" id="adobeID1" name="paid__c" type="hidden"/>
    <input class="field lastFormSubmit1 hidden" id="lastFormSubmit1" name="Form_Submit_Timestamp__c" type="hidden"/>
    <input class="field gCLID1 hidden" id="form-gclid" name="GCLID__c" type="hidden"/>
    <input class="field _mkt_trk hidden" id="form-_mkt_trk" name="_mkt_trk" type="hidden"/>
    <input id="_mktoReferrer" name="_mktoReferrer" type="hidden"/>
    <input id="Solution_Interest__c" name="Solution_Interest__c" type="hidden"/>
    <input type="hidden" name="serv" value=""/>
  
    <div class="eloquaFormRouting">
        <input type="hidden" name="formid" value=""/>
        <input type="hidden" name="formVid" value=""/>
        <input type="hidden" name="munchkinId" value=""/>
        <input id="form-warmtransfer" name="Warm_Transfer_Name__c" value="" type="hidden"/>
    </div>
  
    <input type="hidden" id="utm_campaign" name="utm_campaign__c"/>
    <input type="hidden" id="utm_medium" name="utm_medium__c"/>
    <input type="hidden" id="utm_source" name="utm_source__c"/>
    <input type="hidden" id="utm_content" name="utm_content__c"/>
    <input type="hidden" id="utm_term" name="utm_term__c"/>
  </form>
  `

  export default defaultHtml ;